'use client';
import { createStyles } from '@s7/styles';

var useStyles = createStyles((theme, { color }, {})=>{
    const { themeColor, primaryShade } = theme.fn;
    const shade = primaryShade(themeColor(color, theme.palette.primary.mid));
    return {
        root: {
            display: 'inline',
            backgroundColor: shade,
            color: 'inherit',
            borderRadius: theme.fn.borderRadius('0.5r')
        }
    };
});

export { useStyles as default };
//# sourceMappingURL=Mark.styles.js.map
